// Valorile implicite pentru aplicație
export const PAGINATION = {
    DEFAULT_LIMIT: 10,
    DEFAULT_OFFSET: 0,
    DEFAULT_SORT: 'date',
    // 🆕 Labels și texte UI pentru componenta de paginare (Pagination.tsx)
    PREVIOUS: 'Anterior',
    NEXT: 'Următor',
    FIRST: 'Prima',
    LAST: 'Ultima',
    PAGE: 'Pagina',
    OF: 'din',
    SHOWING: 'Se afișează',
    TO: 'la',
    TOTAL_ITEMS_FALLBACK: '{total} înregistrări',
    ITEMS_PER_PAGE_FALLBACK: 'Elemente pe pagină:',
    // ARIA label pentru containerul de navigare
    ARIA_NAVIGATION: 'Navigare paginare',
};
export const FORM_DEFAULTS = {
    CURRENCY: 'RON',
    DATE_FORMAT: 'YYYY-MM-DD',
};
export const INITIAL_FORM_STATE = {
    type: '',
    amount: 0,
    category: '',
    subcategory: '',
    date: '',
    recurring: false,
    frequency: '',
    description: '',
};
// Feature flags pentru componente LunarGrid
export const LUNAR_GRID_FEATURE_FLAGS = {
    // ✅ ENABLED: State Manager mode completamente functional
    // Fix aplicat pentru validTransactions și keyboard navigation functions
    // Orchestrator pattern activ pentru LunarGrid complex state management
    USE_STATE_MANAGER: true, // false = monolithic pattern, true = orchestrator pattern
    // Alte feature flags pentru dezvoltare graduală
    USE_ENHANCED_KEYBOARD_NAV: true,
    USE_PERFORMANCE_OPTIMIZATIONS: true,
    USE_DEBUG_MODE: false,
};
// LocalStorage Keys
export const STORAGE_KEYS = {
    // Theme and UI preferences
    DARK_MODE: 'darkMode',
    SIDEBAR_EXPANDED: 'sidebar-expanded',
    // LunarGrid preferences
    LUNAR_GRID_DELETE_CONFIRM: 'lunar-grid-delete-confirm',
    LUNAR_GRID_LAST_CATEGORY_UPDATE: 'budget-app-last-category-update',
    LUNAR_GRID_TRANSACTION_TRACKING: 'lunar-grid-transaction-tracking', // DEPRECATED - să fie eliminat când refactorizăm LunarGrid
    // Confirmare sumă finală (checkbox complete)
    LUNAR_GRID_FINAL_AMOUNT_CONFIRM: 'lunar-grid-final-amount-confirm',
    // Recurring Transactions preferences
    RECURRING_LOOK_AHEAD_DAYS: 'recurring-look-ahead-days',
    RECURRING_SHOW_GENERATED: 'recurring-show-generated',
    // FUTURE LUNARGRID PREFERENCES - ușor de adăugat:
    // LUNAR_GRID_AUTO_SAVE_DELAY: 'lunar-grid-auto-save-delay',
    // LUNAR_GRID_SHOW_GRID_LINES: 'lunar-grid-show-grid-lines',
    // LUNAR_GRID_COMPACT_MODE: 'lunar-grid-compact-mode',
    // LUNAR_GRID_KEYBOARD_SHORTCUTS: 'lunar-grid-keyboard-shortcuts',
    // Component state persistence
    TABS_ACTIVE: 'tabs-active',
    EXPANDED_ROWS: 'expanded-rows',
    // Transaction Table preferences
    TRANSACTION_TABLE_COLUMN_ORDER: 'transaction-table-column-order',
    TRANSACTION_TABLE_COLUMN_VISIBILITY: 'transaction-table-column-visibility'
};
// Default values for preferences
export const PREFERENCE_DEFAULTS = {
    // LunarGrid preferences
    DELETE_CONFIRMATION_ENABLED: true,
    // Confirmare sumă finală
    FINAL_AMOUNT_CONFIRMATION_ENABLED: true,
    // Recurring Transactions preferences
    RECURRING_LOOK_AHEAD_DAYS: 90, // default to 90 days
    RECURRING_SHOW_GENERATED: true, // show generated transactions by default
    // FUTURE DEFAULTS - exemplu de extensibilitate:
    // AUTO_SAVE_DELAY: 1000, // ms
    // SHOW_GRID_LINES: true,
    // COMPACT_MODE: false,
    // KEYBOARD_SHORTCUTS_ENABLED: true,
    // UI preferences
    SIDEBAR_EXPANDED: true,
    DARK_MODE: false
};
// MEDIUM 5 FIX: Consolidate hardcoded constants scattered throughout codebase
// Time constants for cache, queries, and timeouts
export const TIME_CONSTANTS = {
    // Cache timeouts (in milliseconds)
    CACHE: {
        STALE_TIME_SHORT: 30 * 1000, // 30 seconds
        STALE_TIME_MEDIUM: 2 * 60 * 1000, // 2 minutes
        STALE_TIME_LONG: 5 * 60 * 1000, // 5 minutes
        GC_TIME: 5 * 60 * 1000, // 5 minutes
        DAILY_CACHE: 5 * 60 * 1000, // 5 minutes for daily transactions
    },
    // UI timeouts
    UI: {
        DEBOUNCE_DELAY: 300, // ms
        SYNC_THROTTLE: 100, // ms
        ANIMATION_DURATION: 300, // ms
        REDUCED_MOTION_DURATION: 100, // ms
        TOAST_DURATION: 3000, // ms
        FOCUS_DURATION: 200, // ms - pentru focus transitions
    },
    // Date/Time values
    DATE: {
        END_OF_DAY_HOURS: 23,
        END_OF_DAY_MINUTES: 59,
        END_OF_DAY_SECONDS: 59,
        END_OF_DAY_MILLISECONDS: 999,
        MIDDAY_HOURS: 12, // Pentru timezone fix în useBalanceCalculator
        DAYS_IN_YEAR: 365,
        HOURS_IN_DAY: 24,
        MINUTES_IN_HOUR: 60,
    },
};
// Performance constants for limits, batch sizes, and thresholds
export const PERFORMANCE_CONSTANTS = {
    // Query limits
    QUERY_LIMITS: {
        DEFAULT_LIMIT: 100,
        TRANSACTION_LIMIT: 100,
        CATEGORY_LIMIT: 50,
        BULK_OPERATION_LIMIT: 100,
    },
    // Batch processing
    BATCH_SIZES: {
        TRANSACTION_BATCH: 50,
        EXPORT_BATCH: 1000,
        IMPORT_BATCH: 500,
    },
    // Memory thresholds
    MEMORY: {
        MAX_ACCOUNTS: 100, // Maximum accounts for performance testing
        LARGE_DATASET_THRESHOLD: 1000,
        PAGINATION_THRESHOLD: 100,
        DOS_PROTECTION_THRESHOLD: 10000, // DoS protection for extremely large arrays
    },
    // Calculation thresholds
    CALCULATION: {
        PERCENTAGE_DECIMAL_PLACES: 2,
        AMOUNT_DECIMAL_PLACES: 2,
        PROGRESS_MAX_VALUE: 100,
        PROBABILITY_DIVISOR: 100,
    },
};
// Validation constants for amounts, lengths, and business rules
export const VALIDATION_CONSTANTS = {
    // Amount validation
    AMOUNTS: {
        MIN_AMOUNT: 0.01,
        MAX_AMOUNT: 1000000,
        LARGE_AMOUNT_WARNING: 100000, // Warn for amounts > 100k RON
        DEFAULT_AMOUNT: 0,
        TEST_AMOUNT_SMALL: 500,
        TEST_AMOUNT_MEDIUM: 1000,
        TEST_AMOUNT_LARGE: 3000,
    },
    // String validation
    STRINGS: {
        MIN_DESCRIPTION_LENGTH: 1,
        MAX_DESCRIPTION_LENGTH: 1000, // Updated to match validation logic
        MIN_CATEGORY_LENGTH: 1,
        MAX_CATEGORY_LENGTH: 100, // Updated to match validation logic
        MIN_ID_LENGTH: 1,
        MAX_ID_LENGTH: 100,
        MAX_FIELD_LENGTH: 500, // Default max length for string fields
        MIN_PRECISION: 0.001, // Minimum precision for amounts
    },
    // Date validation
    DATES: {
        MIN_YEAR: 1900,
        MAX_YEAR: 2100,
        DEFAULT_LOOK_AHEAD_DAYS: 90,
    },
    // Business rules
    BUSINESS: {
        MIN_BALANCE: -1000000, // Minimum allowed balance
        MAX_BALANCE: 1000000, // Maximum allowed balance
        DEFAULT_CURRENCY: 'RON',
        SUPPORTED_CURRENCIES: ['RON', 'EUR', 'USD'],
    },
};
